import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useUser } from '../../context/UserContext';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'My Stars', path: '/my-stars' },
  { label: 'Explore', path: '/explore' },
  { label: 'Gift Shop', path: '/gift-shop' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Claudia', path: '/claudia' },
  { label: 'Nerd Zone', path: '/nerd-zone' },
];

const DesktopNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  const { isLoggedIn: isAuthenticated } = useUser();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: 'none', md: 'flex' },
        background: scrolled
          ? 'rgba(10,10,15,0.95)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled
          ? '1px solid rgba(201,168,124,0.15)'
          : '1px solid transparent',
        transition: 'all 0.3s ease',
        zIndex: 1300,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', maxWidth: 1200, width: '100%', mx: 'auto', px: 3 }}>
        {/* Logo */}
        <Box
          onClick={() => navigate('/')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            cursor: 'pointer',
            '&:hover': { opacity: 0.85 },
          }}
        >
          <AutoAwesomeIcon sx={{ color: '#c9a87c', fontSize: 24 }} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#c9a87c',
              fontSize: '1.1rem',
              letterSpacing: '0.5px',
            }}
          >
            Ivy Astrology
          </Typography>
        </Box>

        {/* Nav Links */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {navLinks.map((link) => (
            <Button
              key={link.path}
              onClick={() => navigate(link.path)}
              sx={{
                color: location.pathname === link.path ? '#c9a87c' : '#ede8e0',
                fontSize: '0.875rem',
                fontWeight: location.pathname === link.path ? 700 : 500,
                px: 1.5,
                py: 1,
                borderRadius: 2,
                position: 'relative',
                '&:hover': {
                  background: 'rgba(201,168,124,0.08)',
                  color: '#c9a87c',
                },
                '&::after': location.pathname === link.path ? {
                  content: '""',
                  position: 'absolute',
                  bottom: 4,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 20,
                  height: 2,
                  borderRadius: 1,
                  background: '#c9a87c',
                } : {},
              }}
            >
              {link.label}
            </Button>
          ))}
        </Box>

        {/* Auth Button */}
        <Box>
          {isAuthenticated ? (
            <IconButton
              onClick={() => navigate('/my-stars')}
              sx={{ color: '#c9a87c' }}
            >
              <AccountCircleIcon />
            </IconButton>
          ) : (
            <Button
              variant="outlined"
              onClick={() => navigate('/my-stars')}
              sx={{
                borderColor: 'rgba(201,168,124,0.4)',
                color: '#c9a87c',
                fontSize: '0.85rem',
                px: 2.5,
                py: 0.8,
                '&:hover': {
                  borderColor: '#c9a87c',
                  background: 'rgba(201,168,124,0.08)',
                },
              }}
            >
              Log In
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default DesktopNav;
